/**
 * @desc getWarehouseByShop
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.warehouseFacadeImpl.getWarehouseByShop.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/getWarehouseByShopCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
